import React, { FC, memo, useEffect, useState } from 'react'

import ImageTransport from '../../../transports/common/image-transport'
import ImageLoadingComponent from '../../app-components/image-loading-component'
import { useCurrentSlideIndex } from '../../../hooks/carousel'
import { Slide } from 'pure-react-carousel'
import { CarouselImage, SlidePlaceholder } from './styles'

export type LazyCarouselSlidesProps = {
    images: ImageTransport[]
    aspectRatio?: string
    horizontalCardHeight?: string
    isAboveFold?: boolean
    imwidth?: number
}

const LazyCarouselSlides: FC<LazyCarouselSlidesProps> = ({
    images,
    aspectRatio,
    horizontalCardHeight,
    isAboveFold = false,
    imwidth,
}) => {
    const currentSlide = useCurrentSlideIndex()
    const [loadedSlides, setLoadedSlides] = useState<Set<number>>(() => new Set([0]))

    useEffect(() => {
        setLoadedSlides(prev => {
            const next = new Set(prev)
            const totalSlides = images.length
            // Load current slide and its immediate neighbors
            next.add(currentSlide)
            next.add((currentSlide + 1) % totalSlides)
            next.add((currentSlide - 1 + totalSlides) % totalSlides)

            // Only update state if new slides were added
            if (next.size === prev.size) {
                return prev
            }
            return next
        })
    }, [currentSlide, images.length])

    return (
        <>
            {images.map((image, index) => {
                const imageUrl = image.url && imwidth ? `${image.url}?imwidth=${imwidth}` : image.url

                return (
                    <Slide index={index} key={image.url}>
                        <CarouselImage horizontalCardHeight={horizontalCardHeight}>
                            {loadedSlides.has(index) ? (
                                <ImageLoadingComponent
                                    src={imageUrl}
                                    alt={image.alt}
                                    paddingTop={aspectRatio}
                                    isEager={isAboveFold && index === 0}
                                />
                            ) : (
                                <SlidePlaceholder paddingTop={aspectRatio} />
                            )}
                        </CarouselImage>
                    </Slide>
                )
            })}
        </>
    )
}

export default memo(LazyCarouselSlides)
